var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("ddd"),
        state: _vm.getState(_vm.$v.recipient.phone_numbers.ddd),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.phone_numbers.ddd),
      },
    },
    [
      _c("EmdInput", {
        attrs: { mask: "(##)", name: "ddd" },
        on: { input: () => _vm.$v.recipient.phone_numbers.ddd.$touch() },
        model: {
          value: _vm.recipient.phone_numbers[0].ddd,
          callback: function ($$v) {
            _vm.$set(_vm.recipient.phone_numbers[0], "ddd", $$v)
          },
          expression: "recipient.phone_numbers[0].ddd",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }